import { CategoryTabIds } from '@shared/constants';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import { CategoryTab, THB, ThbLinkType } from '@shared/types/mylounge';

export const findActiveTab = (tabs: CategoryTab[], id: string) => {
    const index = tabs.findIndex(tab => tab.id === id);
    if (index > -1) {
        return index;
    }
    const allTabIndex = tabs.findIndex(tab => tab.id === CategoryTabIds.ALL);

    return allTabIndex > -1 ? allTabIndex : 0;
};

export const getTabImagesMap = (tabs: CategoryTab[], activeIndex: number, loaded: boolean) => {
    const result: {
        [k: number]: boolean;
    } = {};
    tabs.forEach((_, index) => {
        result[index] = index === activeIndex || loaded;
    });

    return result;
};

export const buildUrlForThb = (thb: THB, categoryTabId: string) => {
    switch (thb.type) {
        case ThbLinkType.CAMPAIGN:
            return buildCampaignUrl(thb.id, categoryTabId);
        case ThbLinkType.TAB:
            return `/event/${thb.id}${window.location.search}`;
        case ThbLinkType.URL:
            return thb.url;
        default:
            return undefined;
    }
};
